import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NotifierService } from 'angular-notifier';
import * as saveAs from 'file-saver';
import { Subject } from 'rxjs';
import { Moedas } from 'src/app/domain/constants/moeda.constant';
import {
  InboundOrderDto,
  OrderAttachmentDto,
} from 'src/app/domain/models/dto/inbound-order.dto';
import { OrdersService } from 'src/app/shared/services/orders.service';
import {
  getStatusClass,
  getStatusLabel,
} from 'src/app/shared/utils/client-status.util';

@Component({
  selector: 'app-order-data',
  templateUrl: './order-data.component.html',
  styleUrls: ['./order-data.component.scss'],
})
export class OrderDataComponent implements OnInit {
  private readonly notifier: NotifierService;
  @Input() boobleModalData: any;
  @Input() rType: string;
  @Input() showDocuments: boolean;
  @Input() commercial: number;
  @Input() iof: number;
  @Input() ir: number;
  @Input() currency: any;

  moedas = Moedas;

  constructor(
    private router: Router,
    notifierService: NotifierService,
    private ordersService: OrdersService
  ) {
    this.notifier = notifierService;
  }

  ngOnInit() {}

  increasePercentage(value: number, percentage: number) {
    return value + value * percentage;
  }

  getIr(rate: number, spread: number, taxIr: number, ptax: number) {
    const residualIr =
      ((this.increasePercentage(rate, spread) < ptax
        ? ptax
        : this.increasePercentage(rate, spread)) *
        this.boobleModalData.amount) /
      (1 - taxIr);
    return residualIr * taxIr;
  }

  getModalityText(modalityCode: number) {
    switch (modalityCode) {
      case 1:
        return 'À Vista';
      case 2:
        return 'Antecipado';
      case 3:
        return 'À Prazo';
      default:
        return '-';
    }
  }

  downloadAttachmentByName(fileName: string) {
    this.ordersService.downloadOrderAttachmentByName(fileName).subscribe({
      next: (data: any) => {
        saveAs(data, fileName);
        this.notifier.notify(
          'success',
          'Download do arquivo realizado com sucesso.'
        );
      },
      error: () => {
        this.notifier.notify('error', 'Erro ao efetuar o download do arquivo.');
      },
    });
  }

  downloadAttachmentById(orderAttachment: OrderAttachmentDto) {
    this.ordersService.downloadOrderAttachment(orderAttachment?.id).subscribe({
      next: (data: any) => {
        saveAs(data, orderAttachment?.fileName);
        this.notifier.notify(
          'success',
          'Download do arquivo realizado com sucesso.'
        );
      },
      error: () => {
        this.notifier.notify('error', 'Erro ao efetuar o download do arquivo.');
      },
    });
  }

  attachmentFileName(fileName: string) {
    return fileName.substring(fileName.lastIndexOf('-') + 1, fileName.length);
  }

  getStatusLabel = getStatusLabel;
  getStatusClass = getStatusClass;
}
